export default "/images/vendor/flag-icons/flags/4x3/kg.svg?4944119101a673f128ceeea43d6f93a7";